import ProductPlacement from '../product-placement';
import IPBoardArrows from './ip-board-arrows';

export default class IPBoardPlacement extends ProductPlacement {
  arrows?: IPBoardArrows;

  extraHeight?: boolean;

  constructor() {
    super();
  }
}
